import { render, staticRenderFns } from "./SupEdit.vue?vue&type=template&id=52b10ffb&scoped=true"
import script from "./SupEdit.vue?vue&type=script&lang=js"
export * from "./SupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b10ffb",
  null
  
)

export default component.exports